var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from "vue";
import { KpiGlobalPerformancePanel } from "./components/kpi-global-performance";
import { KpiCompliancePanel } from "./components/kpi-compliance";
import { KpiComplianceProgressivePanel } from "./components/kpi-compliance-progressive";
import { GdaCentersKpiPanel } from "./components/gda-centers-kpi";
import { currentUser } from "@/core/users/session";
import { fetchDefaultPeriod } from "@/core/period/api";
import { fetchLatestResultsUpdate } from "./api";
import { formatDate } from "@/lib/intl-formatters";
const CANARIAS_REGION_CODE = "S300";
const LEVANTE_REGION_CODE = "E300";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props, { expose: __expose }) {
        __expose();
        const EAST_KPI_REGION_CODES = ["E100", "E200"];
        const currentPeriodLabel = ref("");
        const lastUpdatedAt = ref(null);
        const currentSessionUser = computed(() => currentUser());
        const supportsHomeKpiPanels = computed(() => {
            var _a;
            const user = currentSessionUser.value;
            if (user.area_code === "C" || user.area_code === "N") {
                return true;
            }
            if (user.area_code === "S") {
                return true;
            }
            if (user.area_code === "E") {
                return EAST_KPI_REGION_CODES.includes((_a = user.region_code) !== null && _a !== void 0 ? _a : "");
            }
            return false;
        });
        const supportsComplianceProgressivePanel = computed(() => {
            const user = currentSessionUser.value;
            if (user.area_code === "C") {
                return true;
            }
            return user.area_code === "S" && user.region_code !== CANARIAS_REGION_CODE;
        });
        const supportsGdaCentersPanel = computed(() => {
            const user = currentSessionUser.value;
            if (user.area_code === "C") {
                return true;
            }
            if (user.area_code === "S") {
                return user.region_code !== CANARIAS_REGION_CODE;
            }
            return user.region_code === LEVANTE_REGION_CODE;
        });
        const isLevanteRegionUser = computed(() => {
            const user = currentSessionUser.value;
            return user.region_code === LEVANTE_REGION_CODE;
        });
        const showKpiGlobalPerformancePanel = computed(() => supportsHomeKpiPanels.value && !isLevanteRegionUser.value);
        const showKpiCompliancePanel = computed(() => supportsHomeKpiPanels.value && !isLevanteRegionUser.value);
        const showKpiComplianceProgressivePanel = computed(() => supportsComplianceProgressivePanel.value);
        const showGdaCentersKpiPanel = computed(() => supportsGdaCentersPanel.value);
        const lastUpdatedLabel = computed(() => {
            if (!lastUpdatedAt.value) {
                return "";
            }
            return formatDate(lastUpdatedAt.value, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                const [period, latestResultsUpdate] = yield Promise.all([fetchDefaultPeriod(), fetchLatestResultsUpdate()]);
                currentPeriodLabel.value = period.label;
                lastUpdatedAt.value = latestResultsUpdate.updated_at;
            }
            catch (error) {
                console.error("Error loading home metadata:", error);
            }
        }));
        const __returned__ = { CANARIAS_REGION_CODE, LEVANTE_REGION_CODE, EAST_KPI_REGION_CODES, currentPeriodLabel, lastUpdatedAt, currentSessionUser, supportsHomeKpiPanels, supportsComplianceProgressivePanel, supportsGdaCentersPanel, isLevanteRegionUser, showKpiGlobalPerformancePanel, showKpiCompliancePanel, showKpiComplianceProgressivePanel, showGdaCentersKpiPanel, lastUpdatedLabel, get KpiGlobalPerformancePanel() { return KpiGlobalPerformancePanel; }, get KpiCompliancePanel() { return KpiCompliancePanel; }, get KpiComplianceProgressivePanel() { return KpiComplianceProgressivePanel; }, get GdaCentersKpiPanel() { return GdaCentersKpiPanel; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
